module.exports = __webpack_public_path__ + "img/er.e5e5e397.svg";